import LegalLayout from "./LegalLayout";

export default function ShippingPolicy() {
  return (
    <LegalLayout title="Politique de livraison" updated="23 juillet 2026">
      <p>
        Chez <strong>Délices Mikaté Royal</strong>, nous préparons chaque commande avec soin afin
        d&apos;offrir à nos clients des produits frais et de qualité.
      </p>
      <p>
        Cette politique explique les modalités de livraison et de récupération des commandes effectuées
        sur notre site.
      </p>

      <h2>1. Zones de livraison</h2>

      <h3>Livraison locale régulière</h3>
      <p>
        Délices Mikaté Royal offre un service de livraison locale à <strong>Sorel-Tracy et secteurs
        proches</strong>, dans un rayon habituel de <strong>5&nbsp;km</strong>, selon les
        disponibilités.
      </p>
      <p>
        Cette livraison est disponible pour toute commande d&apos;un montant minimum de{" "}
        <strong>30,00&nbsp;$</strong>. Les modalités et les frais de livraison sont confirmés avec le
        client avant la préparation de la commande.
      </p>

      <h3>Grandes commandes et événements</h3>
      <p>
        Pour les commandes importantes, les événements, les entreprises, les groupes ou toute occasion
        spéciale, la livraison peut également être organisée dans des secteurs plus éloignés, notamment{" "}
        <strong>Rive-Sud</strong>, <strong>Rive-Nord</strong>, <strong>Montréal</strong> et d&apos;autres
        régions sur demande.
      </p>
      <p>Dans ces cas, les frais de livraison sont calculés selon&nbsp;:</p>
      <ul>
        <li>la distance&nbsp;;</li>
        <li>le volume de la commande&nbsp;;</li>
        <li>les besoins spécifiques du client.</li>
      </ul>
      <p>
        Une soumission personnalisée est transmise au client avant confirmation. Aucune adresse
        personnelle, adresse de production ou point de retrait public n&apos;est affiché sur le site.
      </p>

      <h2>2. Retrait de commande</h2>
      <p>
        Les clients peuvent également récupérer leur commande selon les modalités convenues avec Délices
        Mikaté Royal.
      </p>
      <p>Les informations concernant&nbsp;:</p>
      <ul>
        <li>l&apos;heure de récupération&nbsp;;</li>
        <li>le lieu de retrait&nbsp;;</li>
        <li>les instructions particulières</li>
      </ul>
      <p>seront confirmées au moment de la commande.</p>

      <h2>3. Délais de préparation</h2>
      <p>Les délais de préparation varient selon&nbsp;:</p>
      <ul>
        <li>la quantité commandée&nbsp;;</li>
        <li>le type de produits&nbsp;;</li>
        <li>la période de l&apos;année&nbsp;;</li>
        <li>les commandes spéciales ou événements.</li>
      </ul>
      <p>
        Nous recommandons aux clients de commander à l&apos;avance pour les grandes quantités ou les
        événements.
      </p>

      <h2>4. Livraison de produits alimentaires</h2>
      <p>
        Nos produits sont préparés artisanalement et doivent être consommés selon les recommandations
        fournies.
      </p>
      <p>
        Le client est responsable de s&apos;assurer qu&apos;une personne est disponible pour recevoir la
        commande au moment prévu.
      </p>

      <h2>5. Retards de livraison</h2>
      <p>Délices Mikaté Royal met tout en œuvre pour respecter les délais convenus.</p>
      <p>
        Cependant, certains événements indépendants de notre volonté peuvent occasionner des retards,
        notamment&nbsp;:
      </p>
      <ul>
        <li>conditions météorologiques&nbsp;;</li>
        <li>problèmes de circulation&nbsp;;</li>
        <li>circonstances exceptionnelles.</li>
      </ul>
      <p>Nous communiquerons avec le client lorsque des changements importants surviennent.</p>

      <h2>6. Exactitude des informations fournies</h2>
      <p>Le client est responsable de fournir des informations exactes&nbsp;:</p>
      <ul>
        <li>nom&nbsp;;</li>
        <li>numéro de téléphone&nbsp;;</li>
        <li>adresse de livraison&nbsp;;</li>
        <li>instructions particulières.</li>
      </ul>
      <p>Des informations incorrectes peuvent entraîner des retards ou empêcher la livraison.</p>

      <h2>7. Commandes pour événements</h2>
      <p>
        Pour les événements, mariages, festivals, entreprises ou grandes commandes, les modalités de
        livraison peuvent être adaptées selon les besoins spécifiques du client.
      </p>
      <p>Une confirmation détaillée sera établie avant la préparation.</p>

      <h2>8. Contact</h2>
      <p>Pour toute question concernant une livraison&nbsp;:</p>
      <p>
        <strong>Délices Mikaté Royal</strong><br />
        Site Web&nbsp;: <a href="https://www.mikateroyal.com" target="_blank" rel="noreferrer">www.mikateroyal.com</a><br />
        Courriel&nbsp;: <a href="mailto:contact@mikateroyal.com">contact@mikateroyal.com</a>
      </p>
    </LegalLayout>
  );
}
